<template>
    <DateRangePicker
        opens="right"
        :date-range="selectedDate"
        :single-date-picker="true"
        :show-dropdowns="true"
        :show-ranges="false"
        :ranges="false"
        auto-apply
        @select="onSelect"
        :date-format="dateFormat"
        :locale-data="localeData"
        style="width: 100%">
        <template v-slot:input="picker">
            {{ picker.startDate | date }}
        </template>
    </DateRangePicker>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import moment from 'moment';

export default {
    components: {
        DateRangePicker,
    },
    props: {
        value: {
            type: String,
            required: true,
        },
        allowPastDates: {
            type: Boolean,
            required: false,
            default: true,
        },
        allowFutureDates: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
    filters: {
        date(value) {
            if (!value) {
                return 'Select date';
            }
            const options = {
                year: 'numeric',
                month: 'short',
                day: '2-digit',
            };
            return new Date(value).toLocaleDateString(undefined, options);
        },
    },
    data() {
        return {
            localeData: {
                direction: 'ltr',
                format: 'mm/dd/yyyy',
                separator: ' - ',
                applyLabel: 'Apply',
                cancelLabel: 'Cancel',
                weekLabel: 'W',
                customRangeLabel: 'Custom Range',
                daysOfWeek: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                monthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                firstDay: 1,
            },
        };
    },
    computed: {
        selectedDate() {
            return {
                startDate: this.value,
                endDate: this.value,
            };
        },
    },
    methods: {
        dateFormat(classes, date) {
            const cls = classes;
            if (!this.allowPastDates && !cls.disabled) {
                cls.disabled = moment().startOf('date').isSameOrAfter(moment(date));
            }
            if (!this.allowFutureDates && !cls.disabled) {
                cls.disabled = moment().endOf('date').isSameOrBefore(moment(date));
            }
            return cls;
        },
        onSelect(event) {
            const date = moment(event.startDate).format('YYYY-MM-DD');
            this.$emit('input', date);
        },
    },
};
</script>
